<ng-container *transloco="let t">
  <IDropdown [items]="keywordItems" appNavBreadcrumb>
    <IButton
      variant="ghost"
      icon="icon-[lucide--chevron-down]"
      [trailing]="true"
      [label]="(searchTerm$ | async)?.searchTerm"
    />
  </IDropdown>
  <div class="flex h-full flex-col gap-2">
    @if (addProductMessage$ | async; as m) {
      <IAlert type="info" [title]="m.message" />
    }
    <IAlert type="info" [title]="t('keyword-tracker-details.display_only_first_search')" />
    <div class="flex-1 shrink-0">
      <app-keyword-tracking-timeline />
    </div>
  </div>
</ng-container>
